var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"select-input",class:{ active: !!_vm.value },domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},[(_vm.placeholder)?_c('option',{attrs:{"disabled":"","value":""}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._l((_vm.selectOptions),function(ref){
var value = ref.value;
var label = ref.label;
return _c('option',{key:value,domProps:{"value":value}},[_vm._v(" "+_vm._s(label)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }